import { Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { EnvironmentSwitcher } from './EnvironmentSwitcher';
import { useAuth } from '../../context/AuthContext';
import { useEnvironment } from '../../context/EnvironmentContext';
import { Badge } from '../ui/Badge';

export function AppShell() {
  const { user, merchant, logout } = useAuth();
  const { accentGradient } = useEnvironment();

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <header
          className={`sticky top-0 z-10 border-b border-onyx-border bg-onyx-bg/90 backdrop-blur px-6 py-4 flex items-center justify-between gap-4 bg-gradient-to-r ${accentGradient}`}
        >
          <div>
            <h1 className="text-lg font-semibold">{merchant?.name ?? 'Merchant'}</h1>
            <p className="text-xs text-onyx-muted">{user?.email}</p>
          </div>
          <div className="flex items-center gap-4">
            {merchant ? <Badge status={merchant.status} /> : null}
            <EnvironmentSwitcher />
            <button
              type="button"
              onClick={logout}
              className="p-2 rounded-lg text-onyx-muted hover:text-onyx-text hover:bg-onyx-elevated"
              title="Sign out"
            >
              <LogOut size={18} />
            </button>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
